<template>
  <v-select
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    v-model="selectedPaymentMethod"
    @change="onChange"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
    label="Payment Method"
  ></v-select>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
const PAYMENT_METHODS_QUERY = gql`
  query paymentMethods {
    paymentMethods {
      totalCount
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
export default {
  name: "PaymentMethodListSelect",

  props: {
    itemText: {
      type: String,
      default: () => "name",
    },
    itemValue: {
      type: String,
      default: () => "id",
    },
    value: {
      type: String,
      default: () => null,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      selectedPaymentMethod: this.value ? this.value : null,
    };
  },

  computed: {
    items() {
      return this.paymentMethods && this.paymentMethods.edges
        ? this.paymentMethods.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      newVal ? (this.selectedPaymentMethod = newVal) : null;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.selectedPaymentMethod);
    },
  },

  apollo: {
    paymentMethods: {
      query: PAYMENT_METHODS_QUERY,
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/PaymentMethodListSelect.vue